import { render, staticRenderFns } from "./BestProdSection.vue?vue&type=template&id=8c36fbd0&scoped=true&"
import script from "./BestProdSection.vue?vue&type=script&lang=js&"
export * from "./BestProdSection.vue?vue&type=script&lang=js&"
import style0 from "./BestProdSection.vue?vue&type=style&index=0&id=8c36fbd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c36fbd0",
  null
  
)

export default component.exports